module.exports = __webpack_public_path__ + "static/img/2.fd42b314.jpg";